import React from "react";
import { useTranslation } from "react-i18next";
import "../translations/i18n";
import { StaticImage } from "gatsby-plugin-image";
import { AnimatedOnScroll } from "react-animated-css-onscroll";

function About({ language }) {
  const { t } = useTranslation();

  return (
    <section id="about">
      <div className={`${"wholeAbout"} ${language == "ar" ? "ar" : ""}`}>
        <div className="aboutRight">
          {/* <div className="aboutUs"> */}

          <AnimatedOnScroll animationIn="fadeInUp" animationInDelay="500">
            <div className="aboutRightTitle">
              <StaticImage width={20} src="../images/Arrow.svg" alt="arrow" />
              <h1>{t("aboutUsTitle")}</h1>
            </div>
          </AnimatedOnScroll>
          <AnimatedOnScroll animationIn="fadeInUp" animationInDelay="500">
            <p>{t("aboutUsContent")}</p>
          </AnimatedOnScroll>
          {/* </div> */}
        </div>
        <div className="aboutLeft">
          <div className="aboutUs">
            <AnimatedOnScroll animationIn="fadeInUp" animationInDelay="500">
              <div className="aboutRightTitle">
                <StaticImage width={20} src="../images/Arrow.svg" alt="arrow" />
                <h1>{t("vision")}</h1>
              </div>
            </AnimatedOnScroll>

            <AnimatedOnScroll animationIn="fadeInUp" animationInDelay="500">
              <p>{t("visionContent")}</p>
            </AnimatedOnScroll>
          </div>
          <div className="aboutUs">
            <AnimatedOnScroll animationIn="fadeInUp" animationInDelay="500">
              <div className="aboutRightTitle">
                <StaticImage width={20} src="../images/Arrow.svg" alt="arrow" />
                <h1>{t("message")}</h1>
              </div>
            </AnimatedOnScroll>

            <AnimatedOnScroll animationIn="fadeInUp" animationInDelay="500">
              <p>{t("messageContent")}</p>
            </AnimatedOnScroll>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
